module.exports = __webpack_public_path__ + "static/media/crd.74f86307.svg";